import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/authguard.guard';
import { AutoLoginGuard } from './guards/autologin.guard';

const routes: Routes = [
  // {
  //   path: 'tool',
  //   loadChildren: () => import('./pages/form/form.module').then( m => m.FormPageModule),
  //   canActivate: [AuthGuard]
  // },
  // {
  //   path: 'login',
  //   loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule),
  //   canActivate: [AutoLoginGuard]
  // },
  {
    path: '',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'aggiungi-immobile',
    loadChildren: () => import('./pages/aggiungi-immobile/aggiungi-immobile.module').then( m => m.AggiungiImmobilePageModule)
  },
  {
    path: 'aggiungi-immobile-v2',
    loadChildren: () => import('./pages/aggiungi-immobile-v2/aggiungi-immobile-v2.module').then( m => m.AggiungiImmobileV2PageModule)
  },
  {
    path: 'aggiungi-protezioni',
    loadChildren: () => import('./pages/aggiungi-protezioni/aggiungi-protezioni.module').then( m => m.AggiungiProtezioniPageModule)
  },
  {
    path: 'view-pdf',
    loadChildren: () => import('./pages/view-pdf/view-pdf.module').then( m => m.ViewPdfPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
